<app-basic-form [form]="form" [keys]="formKeys"></app-basic-form>
<div  *ngIf="selectedSubject">
    <app-policy-card [item]="selectedSubject" [title]="subjectName" [keys]="subjectKeys" [tooltip]="'Soggetto richiedente'">
    </app-policy-card>
</div>
<div class="d-flex flex-column justify-content-start" *ngIf="showEmptyListMessage">
    <div class="empty-list-disclaimer">Attenzione! Non sono presenti soggetti collegati al contraente</div>
</div>
<div class="card-disclaimer-label mt-2" *ngIf="isDocumentExpired">{{ docExpiredWarnMessage }}</div>
